import { channelClient, RequestPolicies } from 'shared/channels';
import { createEntityClient, EntityClient } from 'shared/channels/entity';
import { mapRecordValues } from 'shared/utils/object';
import type { EditableFieldValuesEntityName } from './fields';
import type { CreateFieldValueModel, EditFieldValueModel, FieldValueModel } from './fieldValueModel';
import { FieldValueEvents, fieldValueContracts } from './fieldValueContracts';

export { fieldValueEntityNames } from './fieldValueContracts';
import { fieldValuesContract } from './fieldValuesContract';

export type FieldValueClient = EntityClient<FieldValueModel, FieldValueEvents>;

/** One client per field value dictionary. */
export const fieldValueClients: Record<EditableFieldValuesEntityName, FieldValueClient> =
  mapRecordValues(fieldValueContracts, (contract) => createEntityClient(contract));

/**
 * Field value changes, saved by the worker straight in the API. Both resolve
 * without data once saved; the store receives the saved values from the
 * dictionary's sync that follows.
 */
export const fieldValuesClient = {
  create(fieldName: EditableFieldValuesEntityName, fieldValues: CreateFieldValueModel[]): Promise<void> {
    return channelClient.request(
      fieldValuesContract,
      'create',
      { fieldName, fieldValues },
      RequestPolicies.mutation
    );
  },

  edit(fieldName: EditableFieldValuesEntityName, fieldValues: EditFieldValueModel[]): Promise<void> {
    return channelClient.request(fieldValuesContract, 'edit', { fieldName, fieldValues }, RequestPolicies.mutation);
  },
};
